import React from 'react';
import { FaCheckCircle, FaDesktop } from 'react-icons/fa';
import { URLV1 } from '~/Components/Navbar/links';
import { EMPREENDIMENTO_LANCAMENTO } from '~/constant';
import AuthStorage from '~/Utils/AuthStorage';

const VendaGravada = ({ vendaGravada, codigoProspecto }) => {
  const color = vendaGravada.efetivada ? '#28A745' : '#FFC107';
  const isLancamento = AuthStorage.isAtendenteLancamento();
  const mapaHref = isLancamento && EMPREENDIMENTO_LANCAMENTO
    ? `/mapa/${EMPREENDIMENTO_LANCAMENTO}`
    : '/mapa';

  return (
    <div className="text-center">
      <FaCheckCircle color="#28A745" fontSize={72} />
      <h4>
        Venda{' '}
        <span style={{ color: color }}>
          {vendaGravada.efetivada ? 'Realizada' : 'Gravada para Aprovação'}
        </span>
        !
      </h4>
      <div className="row">
        <div className="col-md-12">
          <h4>Proposta: {vendaGravada.codigo_proposta}</h4>
          {vendaGravada.codigos_pre_vendas &&
            vendaGravada.codigos_pre_vendas.map(codigo => (
              <div className="text-center d-block" key={codigo}>
                <a
                  className="btn btn-outline-primary"
                  target="blank"
                  href={`${URLV1}/Comercial/PreVendaPropostaRapida.aspx?PreVenda=${codigo}`}
                >
                  Ver proposta da Pré-venda - {codigo}
                </a>
              </div>
            ))}
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-md-6">
          <a
            className="btn btn-outline-primary mr-3"
            href={`/AdministracaoVendas?codigo_proposta=${vendaGravada.codigo_proposta}${codigoProspecto ? '&codigo_prospecto=' + codigoProspecto : ''}`}
          >
            Administração de vendas
          </a>
        </div>
        <div className="col-md-6">
          <a
            className="btn btn-outline-primary ml-3"
            href={mapaHref}
          >
            Mapa do empreendimento
          </a>
        </div>
      </div>
      {isLancamento && (
        <div className="row mt-3">
          <div className="col-md-12">
            <a
              className="btn btn-primary"
              href="/lancamento/colaborador/atendimento"
            >
              <FaDesktop className="mr-1" />
              Voltar para Atendimento
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendaGravada;
